import { getCurrentIsoWeek } from '../../../utils/dateUtils';
import type { BedResource, PlanningIssue, WeekKpi } from './types';

// Subset of WeekKpi the BE does not yet return. `computeWeekKpi` merges this
// with the fields it computes itself: the calculation status and profession
// hours are real BE data, while patientsCount is derived from the year plan and
// bedsCount is still a demo approximation of it (see `mockBedsCount`).
// Planning issues and bed resources are mocked outright, here.
// TODO: drop this file when BE catches up.
export type MockedWeekKpiFields = Pick<WeekKpi, 'planningIssues' | 'bedResources'>;

// Anchor follows the current ISO week so the demo never goes stale: the seeded
// issues are computed relative to now.
const CURRENT_WEEK = getCurrentIsoWeek();
const UNPLANNED_ISSUE_OFFSET = 3;
const BED_OVERBOOK_OFFSET = 6;

const UNPLANNED_COUNT = 20;

const SEEDED_OVERBOOKS: readonly BedResource[] = [
  {
    title: 'Barriatri rum er overbooket',
    used: 3,
    threshold: { limit: 2 },
    affectedPatients: ['Morten Østergaard', 'Pia Kjærsgaard', 'Mette Frederiksen']
  },
  {
    title: 'Kørestole er overbooket',
    used: 11,
    threshold: { limit: 8 },
    affectedPatients: ['Freja Mikkelsen', 'Lasse Brandt', 'Signe Holgersen']
  }
];

export const getMockWeekKpi = (weekNumber: number): MockedWeekKpiFields => {
  let planningIssues: readonly PlanningIssue[] = [];
  let bedResources: readonly BedResource[] = [];

  if (weekNumber === CURRENT_WEEK + UNPLANNED_ISSUE_OFFSET) {
    planningIssues = [{ code: 'UPLANLAGTE', count: UNPLANNED_COUNT }];
  } else if (weekNumber === CURRENT_WEEK + BED_OVERBOOK_OFFSET) {
    bedResources = SEEDED_OVERBOOKS;
  }

  return { planningIssues, bedResources };
};
